<template>
  <v-container
    id="detalhe-clientes-devolucao-impropria-form"
    fluid
    tag="section"
    class="px-3 pt-0"
    style="margin-top: 1rem"
  >
    <v-row>
      <v-col
        cols="12"
        lg="12"
        class="px-1"
      >
        <v-row>
          <v-col
            cols="12"
            class="container"
          >
            <dashboard-filtro-datas
              :primeiro="enablePrimeiroDia"
              :ultimo="enableUltimoDia"
              :empresas="enableEmpresa"
              :vendedores="enableVendedor"
              :supervisores="enableSupervisor"
              :areas="enableArea"
              :redes="enableRede"
              :receitas="enableReceita"
              :segmentos="enableSegmento"
              :url="link"
              :categorias="enableCategoria"
              :promotores="enablePromotor"
              :cidades="enableCidades"
              :classificacoes="enableClassificacao"
              :linha-producao="enableLinhaProducao"
            />
            <v-divider class="mb-5" />
            <v-row>
              <v-col
                cols="12"
                sm="12"
                md="12"
                lg="12"
              >
                <v-card
                  class="mx-auto"
                  outlined
                >
                  <v-list-item three-line>
                    <v-list-item-content
                      id="listItemPrincipaisClientes"
                      class="pr-10"
                      :style="dynamicPaddingCliente7"
                    >
                      <div class="text-overline mb-4 highlighted-item">
                        <v-icon
                          id="iconInformationDevolucaoClientes"
                          class="text-left"
                        >
                          mdi-clipboard-arrow-left
                        </v-icon>
                        Quais os clientes com maior devolução?
                      </div>
                    </v-list-item-content>
                    <v-btn
                      id="btnPrint"
                      small
                      :color="corPrimaria"
                      dark
                      :disabled="enableBtn"
                      :loading="imprimindo"
                      @click="imprimir()"
                    >
                      <v-icon>
                        mdi-printer
                      </v-icon>
                      Imprimir
                      <template v-slot:loader>
                        <span>Imprimindo...</span>
                      </template>
                    </v-btn>
                    <v-tooltip
                      top
                      max-width="400"
                      width="400"
                    >
                      <template
                        v-slot:activator="{ on, attrs }"
                      >
                        <v-icon
                          id="iconInformationDevolucaoClientes"
                          class="text-left"
                          v-bind="attrs"
                          v-on="on"
                          @mouseover="enableTexto('337')"
                        >
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <div
                        v-if="!carregandoTooltip"
                        v-html="textoOrientacao"
                      />
                    </v-tooltip>
                  </v-list-item>
                  <v-card-actions>
                    <v-row>
                      <v-col
                        cols="12"
                        sm="12"
                        md="12"
                        lg="12"
                      >
                        <div
                          v-if="loading"
                          :style="styleObject"
                          class="text-center"
                        >
                          <v-icon
                            light
                            class="custom-loader"
                            :style="styleObject"
                          >
                            mdi-cached
                          </v-icon>
                          Carregando dados...
                        </div>
                        <div
                          v-else-if="error"
                          class="alert alert-danger"
                        >
                          {{ error }}
                        </div>
                        <div
                          v-else
                        >
                          <div
                            id="idTable"
                            style="overflow-x: auto; max-width: 100%;"
                          >
                            <table
                              style="width: 100%; table-layout: fixed; color: black; border-collapse: collapse;"
                              class="elevation-1"
                            >
                              <thead>
                                <tr>
                                  <th
                                    id="dadoMovimentacaoHeader"
                                    style="text-align: center;"
                                    class="black--text title"
                                  >
                                    Cliente
                                  </th>
                                  <th
                                    id="dadoMovimentacaoHeader"
                                    style="text-align: center;"
                                    class="black--text title"
                                  >
                                    Vendedor
                                  </th>
                                  <th
                                    id="dadoMovimentacaoHeader"
                                    style="text-align: center;"
                                    class="black--text title"
                                  >
                                    Valor da venda
                                  </th>
                                  <th
                                    id="dadoMovimentacaoHeader"
                                    style="text-align: center;"
                                    class="black--text title"
                                  >
                                    Valor de devolução
                                  </th>
                                  <th
                                    id="dadoMovimentacaoHeader"
                                    style="text-align: center;"
                                    class="black--text title"
                                  >
                                    % de devolução
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr
                                  v-for="item in devolucaoClientes"
                                  :key="item.id"
                                >
                                  <td
                                    id="dadoMovimentacao"
                                    style="text-align: left;"
                                  >
                                    {{ item.nome_cliente }}
                                  </td>
                                  <td
                                    id="dadoMovimentacao"
                                    style="text-align: left;"
                                  >
                                    {{ item.vendedor }}
                                  </td>
                                  <td
                                    id="dadoMovimentacao"
                                    style="text-align: right;"
                                  >
                                    {{ item.valor_venda }}
                                  </td>
                                  <td
                                    id="dadoMovimentacao"
                                    style="text-align: right;"
                                  >
                                    {{ item.valor_devolucao }}
                                  </td>
                                  <td
                                    id="dadoMovimentacao"
                                    style="text-align: right;"
                                    :style="getColor(item.porcentagem)"
                                  >
                                    {{ item.porcentagem }}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </v-col>
                    </v-row>
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <dashboard-core-snackbar
      v-model="snackbar.visible"
      :visible="snackbar.visible"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      :message="snackbar.message"
    />
  </v-container>
</template>

<script>
  import Clientes from '../../../../../services/somentecliente4'
  import Permissao from '../../../../../services/menu'
  import eventEmit from '../../../components/core/EventoEmit'
  import JSPDF from 'jspdf'
  import 'jspdf-autotable'

  export default {
    name: 'ShowDetalheDevolucaoImpropria',
    components: {
      // DashboardFiltroDatas: () => import('../../components/core/FiltroDatas'),
      DashboardFiltroDatas: () => import('../../../components/core/FiltroDatas'),
      DashboardCoreSnackbar: () => import('../../../components/core/Snackbar'),
    },
    data: () => ({
      appOnline: navigator.onLine,
      corPrimaria: localStorage.corPrimaria,
      corSecondaria: localStorage.corSecondaria,
      styleObjectIcon: {
        color: '#4780b8',
      },
      styleObject: {
        color: localStorage.corPrimaria,
      },
      valorReceber: localStorage.valorReceber,
      valorVencido: 0,
      paginaEnable: false,
      permissaoContasReceber: '',
      primeiroDia: (new Date(localStorage.dataInicial)).toISOString().substr(0, 10),
      ultimoDia: (new Date(localStorage.dataFinal)).toISOString().substr(0, 10),
      select: JSON.parse(localStorage.getItem('empresaId')),
      empresa: [],
      vendedorSelect: JSON.parse(localStorage.getItem('vendedoresId')),
      vendedores: [],
      filterVendedores: [],
      areaSelect: [],
      redeSelect: [],
      redes: [],
      filterRede: [],
      supervisorSelect: [],
      supervisor: [],
      filterSupervisor: [],
      receitaSelect: [],
      receita: [],
      filterReceita: [],
      segmento: [],
      selectSegmento: [],
      filterSegmento: [],
      categoria: [],
      selectCategoria: [],
      filterCategoria: [],
      promotor: [],
      selectPromotor: [],
      filterPromotor: [],
      linhaProducao: [],
      classificacao: [],
      cidades: [],
      enablePrimeiroDia: true,
      enableUltimoDia: true,
      enableEmpresa: true,
      enableVendedor: true,
      enableSupervisor: true,
      enableArea: true,
      enableRede: true,
      enableReceita: true,
      enableSegmento: true,
      enableCategoria: true,
      enablePromotor: true,
      enableCidades: true,
      enableClassificacao: true,
      enableLinhaProducao: true,
      link: localStorage.linkClientes,
      menu: false,
      menu1: false,
      dataInicialImpressao: false,
      dataFinalImpressao: false,
      codigo: 0,
      orientacao: [],
      textoDetalhesClienteDevolucaoImpropria: '',
      headersDevolucaoClientes: [
        { text: 'Cliente', value: 'nome_cliente', align: 'left', class: 'black--text title' },
        { text: 'Vendedor', value: 'vendedor', align: 'left', class: 'black--text title' },
        { text: 'Rede', value: 'rede', align: 'left', class: 'black--text title' },
        { text: 'Valor da venda', value: 'valor_venda', align: 'right', class: 'black--text title' },
        { text: 'Valor de devolução', value: 'valor_devolucao', align: 'right', class: 'black--text title' },
        { text: '% de devolução', value: 'porcentagem', align: 'right', class: 'black--text title' },
      ],
      devolucaoClientes: [],
      snackbar: {
        visible: false,
        color: 'success',
        direction: 'top center',
        message: 'My timeout is set to 3000.',
        timeout: 3000,
      },
      loading: false,
      error: null,
      enableBtn: true,
      imprimindo: false,
      textoOrientacao: '',
      carregandoTooltip: false,
      codigoAtual: null,
    }),

    computed: {
      computedDateFormatted () {
        return this.formatDate(this.ultimoDia)
      },

      computedPrimeiroDia () {
        return this.formatDatePrimeiroDia(this.primeiroDia)
      },
    },

    created () {
      eventEmit.$on('update-dados', this.handleUpdateDados)
    },

    beforeDestroy () {
      eventEmit.$off('update-dados', this.handleUpdateDados)
    },

    mounted () {
      if (localStorage.tokencontrato) {
        this.usuarioIdentificado = true

        this.paginaEnable = true

        if (!this.paginaEnable) {
          this.$router.push('/dashboard')
        }
      } else {
        this.usuarioIdentificado = false
        localStorage.removeItem('username')
        localStorage.removeItem('email')
        localStorage.removeItem('nome')
        localStorage.removeItem('usuarioIdentificado')
        this.$router.push('/login')
      }
    },

    methods: {
      handleUpdateDados (primeiroDia, dataFinal, select, vendedor, area, rede, supervisor, receita, segmento, classificacao, produto, cidade, categoria, promotor, linhasProducao) {
        this.primeiroDia = primeiroDia
        this.ultimoDia = dataFinal
        this.select = select
        this.vendedorSelect = vendedor
        this.areaSelect = area
        this.redeSelect = rede
        this.supervisorSelect = supervisor
        this.receita = receita
        this.segmento = segmento
        this.categoria = categoria
        this.promotor = promotor
        this.classificacao = classificacao
        this.linhaProducao = linhasProducao
        this.cidades = cidade

        localStorage.setItem('updateDadosFiltros', true)
        localStorage.setItem('dataInicial', this.primeiroDia)
        localStorage.setItem('dataFinal', this.ultimoDia)
        localStorage.setItem('empresaId', JSON.stringify(this.select || []))
        localStorage.setItem('vendedoresId', JSON.stringify(vendedor || []))
        localStorage.setItem('supervisor', JSON.stringify(this.supervisorSelect || []))
        localStorage.setItem('receita', JSON.stringify(this.receita || []))

        this.formatarDatasImpressao()

        this.showDadosDevolucaoClientes()
      },

      async showDadosDevolucaoClientes () {
        this.loading = true
        this.devolucaoClientes = []

        await Clientes.showDetalheClientes4Devolucao(this.primeiroDia, this.ultimoDia, this.select, this.vendedorSelect, localStorage.tokencontrato, this.areaSelect, this.redeSelect, this.supervisorSelect, this.receita, this.segmento, this.categoria, this.promotor, this.classificacao, this.linhaProducao, this.cidades).then(resposta => {
          if (resposta.data.status) {
            this.enableBtn = false

            this.devolucaoClientes = resposta.data.dadosDevolucaoClientes.map((item) => {
              var listaDevolucaoClientes = ({
                nome_cliente: item.nome_cliente,
                vendedor: item.vendedor,
                rede: item.rede,
                valor_venda: item.valor_venda ? item.valor_venda.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) : '-',
                valor_devolucao: item.valor_devolucao.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                porcentagem: item.porcentagem.toFixed(2).toString().replace('.', ',') + '%',
              })

              return listaDevolucaoClientes
            })

            console.log(this.devolucaoClientes)
          } else if (resposta.data.msg === 'Não há dados de devolução no período selecionado') {
            this.devolucaoClientes = []

            this.showSnackbar('error', 3000, resposta.data.msg)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => {
          this.loading = false
        })
      },

      getColor (value) {
        var porcentagem = parseFloat(value.replace(',', '.'))

        if (porcentagem >= 100) {
          return 'color: red'
        } else {
          return 'color: green'
        }
      },

      async enableTexto (value) {
        if (this.codigoAtual === value && this.textoOrientacao) return

        this.codigoAtual = value
        this.carregandoTooltip = true
        this.textoOrientacao = ''

        try {
          const resposta = await Permissao.showOrientacaoIndicador(localStorage.username, localStorage.tokencontrato, value)

          if (resposta.data.status) {
            this.textoOrientacao = resposta.data.orientacao
            this.codigo = value
          }
        } catch (e) {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        } finally {
          this.carregandoTooltip = false
        }
      },

      async imprimir () {
        try {
          this.imprimindo = true

          await setTimeout(() => {
            this.print()
          }, 2000)
        } catch (error) {
          console.error('Erro ao imprimir:', error)
        }
      },

      quebrarString (str, limiteCaracteresPorLinha) {
        const palavras = str.split(' ')
        let linhaAtual = ''
        const linhas = []

        palavras.forEach(palavra => {
          if ((linhaAtual + palavra).length <= limiteCaracteresPorLinha) {
            linhaAtual += palavra + ' '
          } else {
            linhas.push(linhaAtual.trim())
            linhaAtual = palavra + ' '
          }
        })

        if (linhaAtual !== '') {
          linhas.push(linhaAtual.trim())
        }

        return linhas
      },

      async print () {
        try {
          const pdf = new JSPDF('landscape', 'mm')

          // Função para adicionar tabela e controlar quebra de página
          const addTable = async (data, headers, title, posY, fontSize) => {
            pdf.text(title, 15, posY)
            posY += pdf.getTextDimensions(title).h

            pdf.autoTable({
              head: [headers.map(header => ({ content: header.text, styles: { fontSize: fontSize, textColor: [0, 0, 0] } }))],
              body: data.map(row => row.map(cell => ({ content: cell, styles: { fontSize: 8, textColor: [0, 0, 0] } }))),
              startY: posY,
              styles: { fontSize: fontSize },
            })

            posY = 20

            return posY
          }

          let posYFiltros = 10

          const title = 'Filtros selecionados'
          pdf.text(title, 105, posYFiltros)

          const dataInicial = this.primeiroDia.substr(8) + '/' + this.primeiroDia.substr(5, 2) + '/' + this.primeiroDia.substr(0, 4)
          const ultimoDia = this.ultimoDia.substr(8) + '/' + this.ultimoDia.substr(5, 2) + '/' + this.ultimoDia.substr(0, 4)

          const datas = 'Data inicial: ' + dataInicial + ' - Data final: ' + ultimoDia
          posYFiltros += 10
          pdf.setFontSize(10)
          pdf.text(datas, 15, posYFiltros)

          posYFiltros += 10

          const adicionarFiltros = async (pdf, posYFiltros, titulo, dados) => {
            if (dados.length > 0) {
              let texto = titulo + ' '

              for (let i = 0; i < dados.length; i++) {
                texto += dados[i] + ', '
              }

              texto = texto.slice(0, -2)

              const linhas = this.quebrarString(texto, 135)

              linhas.forEach((linha, index) => {
                if (posYFiltros === 200) {
                  pdf.addPage()

                  posYFiltros = 10

                  pdf.text(linha, 15, posYFiltros)

                  posYFiltros += 10
                } else {
                  pdf.text(linha, 15, posYFiltros)

                  posYFiltros += 10
                }
              })
            }

            return posYFiltros
          }

          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Empresa(s) Selecionada(s):', this.select.map(e => e.nomeExibicao))
          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Vendedor(es) Selecionado(s):', this.vendedorSelect.map(v => v.vendedor))
          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Área(s) Selecionada(s):', this.areaSelect.map(a => a.area))
          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Rede(s) Selecionada(s):', this.redeSelect.map(r => r.rede))
          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Supervisor(es) Selecionado(s):', this.supervisorSelect.map(s => s.supervisor))
          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Receita(s) Selecionada(s):', this.receitaSelect.map(re => re.nome))
          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Segmento(s) Selecionado(s):', this.selectSegmento.map(se => se.segmento))

          if (posYFiltros > 70) {
            pdf.addPage()

            posYFiltros = 10
          }

          const titleTable = ' Quais os clientes com maior devolução imprópria?'
          const table = this.devolucaoClientes.map(item => [item.nome_cliente, item.vendedor, item.rede, item.valor_venda, item.valor_devolucao, item.porcentagem])
          posYFiltros = await addTable(table, this.headersDevolucaoClientes, titleTable, posYFiltros, 8)

          pdf.save('relatorio_detalhe_devolucao_impropria.pdf')
        } catch (error) {
          console.error('Erro ao gerar PDF:', error)
        } finally {
          this.imprimindo = false
        }
      },

      formatarDatasImpressao () {
        var partesInicial = this.primeiroDia.split('-')
        var ano = partesInicial[0]
        var mes = partesInicial[1]
        var dia = partesInicial[2]
        this.dataInicialImpressao = dia + '/' + mes + '/' + ano

        var partesFinal = this.ultimoDia.split('-')
        var anoFinal = partesFinal[0]
        var mesFinal = partesFinal[1]
        var diaFinal = partesFinal[2]
        this.dataFinalImpressao = diaFinal + '/' + mesFinal + '/' + anoFinal
      },

      formatDate (date) {
        if (!date) {
          return null
        }

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },

      formatDatePrimeiroDia (date) {
        if (!date) {
          return null
        }

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },

      parseDate (date) {
        if (!date) return null

        const [month, day, year] = date.split('/')
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
      },

      filtrarEmpresa () {
        this.filterVendedores = []
        this.filterRede = []
        this.filterSupervisor = []
        this.filterReceita = []
        this.filterSegmento = []
        this.filterCategoria = []
        this.filterPromotor = []

        if (this.select && this.select.length > 0) {
          this.select.forEach(empresa => {
            const vendedor = this.vendedores.filter(vendedor => vendedor.nomeBd === empresa.nome_bd)

            this.filterVendedores.push(...vendedor)

            const redesAux = this.redes.filter(r => r.nomeBd === empresa.nome_bd)

            this.filterRede.push(...redesAux)

            const supervisorAux = this.supervisor.filter(s => s.nomeBd === empresa.nome_bd)

            this.filterSupervisor.push(...supervisorAux)

            const receitaAux = this.receita.filter(rc => rc.nomeBd === empresa.nome_bd)

            this.filterReceita.push(...receitaAux)

            const segmentoAux = this.segmento.filter(sg => sg.nomeBd === empresa.nome_bd)

            this.filterSegmento.push(...segmentoAux)

            const categoriaAux = this.categoria.filter(c => c.nomeBd === empresa.nome_bd)

            this.filterCategoria.push(...categoriaAux)

            const promotorAux = this.promotor.filter(p => p.nomeBd === empresa.nome_bd)

            this.filterPromotor.push(...promotorAux)
          })
        }

        this.filterVendedores.sort((a, b) => a.vendedor.localeCompare(b.vendedor))

        this.filterRede.sort((a, b) => a.rede.localeCompare(b.rede))

        this.filterSupervisor.sort((a, b) => a.supervisor.localeCompare(b.supervisor))

        this.filterReceita.sort((a, b) => a.nome.localeCompare(b.nome))

        this.filterSegmento.sort((a, b) => a.segmento.localeCompare(b.nome))

        this.filterCategoria.sort((a, b) => a.categoria.localeCompare(b.categoria))

        this.filterPromotor.sort((a, b) => a.promotor.localeCompare(b.promotor))
      },

      showSnackbar (color, timeout, message) {
        this.snackbar.message = message
        this.snackbar.color = color
        this.snackbar.visible = true
        this.snackbar.timeout = timeout
      },
    },
  }
</script>

<style scoped>
  .no-list-style {
    list-style-type: none;
    padding: 0;
    margin: 0
  }

  .no-list-style li {
    text-decoration: none
  }

  .hidden {
    display: none
  }

  @media screen
  and (min-device-width : 320px)
  and (max-device-width : 680px) {
    #headersDevolucaoClientes {
      width: 100% !important;
    }

    #idTable {
      max-height: 500px;
    }

    #dadoMovimentacao {
      font-size: 8.5px;
    }

    th, td {
      padding: 8px;
    }
  }

  @media screen
  and (min-width : 681px)
  and (max-width : 960px)
  and (-webkit-min-device-pixel-ratio: 1) {
    #headersDevolucaoClientes {
      max-width: 100%;
    }
  }

  #idTable {
    overflow-x: auto;
    overflow-y: auto;
    max-height: 600px;
  }

  #dadoMovimentacao {
    font-size: 12px;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    font-family: Roboto, sans-serif;
    border: 1px solid #e0e0e0;
  }

  thead th {
    position: sticky;
    top: 0;
    z-index: 2;
    background-color: #f5f5f5;
  }

  th, td {
    border: 1px solid #e0e0e0;
    padding: 10px;
    color: #424242;
  }

  thead {
    background-color: #f5f5f5;
  }

  tbody tr:hover {
    background-color: #f0f0f0;
  }

  #textoTabela {
    font-size: 0.75rem !important
  }

  #dadoMovimentacaoHeader {
    font-size: 12px !important;
    font-weight: 800 !important;
  }

  .custom-loader {
    animation: loader 1s infinite;
    display: flex;
    @-moz-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-webkit-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-o-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)
  }
</style>

<style lang="sass">
  @media print
    #app-bar
      display: none !important

    #core-navigation-drawer
      display: none !important

    #filtrosId
      display: none !important

    #btnPrint
      display: none !important

    #iconInformationDevolucaoClientes
      display: none !important

    .no-list-style
      list-style-type: none
      padding: 0
      margin: 0
      display: block

    .no-list-style li
      display: block
      text-decoration: none

    .hidden
      display: flex !important

    #relatorioMelhoresClientesFaturados
      margin: -7rem 0 0 -6rem

</style>
